import React, { Component, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import ShippingAddressSkeleton from "./../component/ShippingAddressSkeleton";
import $ from "jquery";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { API_BASE_URL } from "../utils/app_url";

const deleteIcon = require("./../assets/img/delete-icon3.svg").default;
const editIcon = require("./../assets/img/edit-icon.svg").default;

const ShippingAddress = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();

  const [loading, setLoading] = useState(true);
  const [allDetails, seAllDetails] = useState();

  const fetchShipping = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}users/shipping`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        seAllDetails(responseData.data);
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const deleteShipping = async id => {
    const confirmDelete = window.confirm(langJson?.areyousureyouwanttodelete);

    if (confirmDelete) {
      try {
        const response = await fetch(`${API_BASE_URL}users/shipping/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          let tempArray = allDetails.filter(item => parseInt(item.id) !== parseInt(id));
          seAllDetails(tempArray);
        } else {
        }
      } catch (error) { }
    }
  };

  useEffect(() => {
    fetchShipping();
  }, []);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>

      <div className="mainDiv">
        <div className="acctHdn topNew">
          <div className="hdnSec">
            {loading ? (
              <HeadingSkeleton width="240px" height="34px" />
            ) : (
              <h2 className="storeTabHdn">{langJson?.shippingaddress}</h2>
            )}
            {loading ? (
              <div className="skeleton" style={{ width: 160, height: 42, borderRadius: 8, float: "right" }} />
            ) : (
              <Link to="/add-address" className="editProfileBtn addAddreBtn">
                {langJson?.addnewaddress}
              </Link>
            )}
          </div>

          {loading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <ShippingAddressSkeleton key={`shipping-skeleton-${index}`} />
            ))
          ) : allDetails?.length > 0 ? (
            <>
              {allDetails?.map((item, index) => (
                <div className="myaccountDiv shipDiv" key={index}>
                  <ul>
                    <li>
                      <label>{langJson?.fullname}</label>
                      {item?.name}
                    </li>
                    <li>
                      <label>{langJson?.address}</label>
                      {item?.address}
                    </li>
                    <li>
                      <label>{langJson?.zipcode}</label>
                      {item?.zip_code}
                    </li>
                    <li>
                      <label>{langJson?.city}</label>
                      {item?.city}
                    </li>
                    <li>
                      <label>{langJson?.country}</label>
                      {item?.country}
                    </li>
                    <li>
                      {/* <button className="removeBtn" onClick={() => deleteShipping(item?.id)}>
                        {langJson?.remove}
                      </button>
                      <Link to={`/edit-address/${item?.id}`} className="orderBtn">
                        <button className="editBtn">{langJson?.edit}</button>
                      </Link> */}
                      <Link to={`/edit-address/${item?.id}`} className="orderBtn">
                        <img src={editIcon} alt="" />
                      </Link>
                      <img src={deleteIcon} alt="" onClick={() => deleteShipping(item?.id)} />
                    </li>
                  </ul>

                  <h3 className="dflt">
                    <input type="radio" />
                    {langJson?.useasdefaultaddress}
                  </h3>
                </div>
              ))}
            </>
          ) : !loading ? (
            <ul className="addressStore">
              <li>
                <h3>{langJson?.norecordsfound}</h3>
              </li>
            </ul>
          ) : null}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShippingAddress;
